import { BaseDialog } from '@/components/dialog/base-dialog'
import { Column, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage } from '@/utils/layer'
import { useUnmount } from 'ahooks'
import React from 'react'
import { goodsLibraryStore } from '../../goods-storage/goods-library/store/goods-library'
import SortGoodsGroup from './component/sort-goods-group'
import SortGoodsList from './component/sort-goods-list'
import { sortGoodStore } from './model'
import './sort-good.scss'

interface GoodsLibrarySortProps {}

const GoodsLibrarySort: React.FC<GoodsLibrarySortProps> = () => {
    const cls = useBemClass('goods-library-sort')

    useUnmount(() => {
        if (sortGoodStore.goodUpdate) {
            goodsLibraryStore.setUpdateGroupStatus()
            sortGoodStore.setGoodUpdate(false)
        }
        if (sortGoodStore.groupUpdate) {
            goodsLibraryStore.setUpdateGroup()
            sortGoodStore.setGroupUpdate(false)
        }
    })

    return (
        <BaseDialog
            isShow
            title="商品排序"
            onClose={() => {
                layerManage.pop()
                sortGoodStore.setActiveId(void 0)
                sortGoodStore.setSecondId(0)
            }}
        >
            <div className={cls('des')}>*拖拽卡片调整分组/商品排序的优先级，越靠上的排序优先级越高</div>
            <Row data-aling-items-center className={cls('container')}>
                <Column>
                    <div className={cls('group-title')}>分组名</div>
                    <div className={cls('group')}>
                        <SortGoodsGroup />
                    </div>
                </Column>
                <SortGoodsList />
            </Row>
        </BaseDialog>
    )
}

export default GoodsLibrarySort
